import { faShoePrints, faBars } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import VerAtendimento from "../../../../../../Components/CardsPages/Atendimento/VerAtendimento";
import LeiaMais from "../../../../../../Components/Utils/LeiaMais";
import { IAtendimentoVinculadoAAtendimento } from "../../../../../../Interfaces/AssistenciaTecnica/Agendamento/AgendamentoInterfaces";
import { ACESSOS } from "../../../../../../Routes/Acessos";

interface IAtendimentoVinculadoDeAgendamentoProps {
    atendimentoVinculado: IAtendimentoVinculadoAAtendimento;
}

export default function AtendimentoVinculadoDeAgendamento(
    props: IAtendimentoVinculadoDeAgendamentoProps
) {
    const atendimentoVinculado = props.atendimentoVinculado;

    return (
        <li className="d-flex justify-content-between my-7">
            <span>
                <div>
                    <LeiaMais charLimit={50} disabled customLeiaMais="">
                        {atendimentoVinculado.DS_CASO}
                    </LeiaMais>
                </div>
                <div className="d-flex align-items-center g-2 my-1">
                    <FontAwesomeIcon
                        icon={faShoePrints}
                        className="text-info"
                        style={{
                            width: "20px",
                        }}
                    />
                    {atendimentoVinculado.DS_ETAPA_TIPO_CASO}
                </div>
                <div className="d-flex align-items-center g-2 my-1">
                    <FontAwesomeIcon
                        icon={faBars}
                        className="text-danger"
                        style={{
                            width: "20px",
                        }}
                    />
                    {atendimentoVinculado.DS_CATEGORIA}
                </div>
            </span>
            <span className="flex-grow-1 d-flex justify-content-end">
                <VerAtendimento
                    ID_CASO={atendimentoVinculado.ID_CASO}
                    ID_TIPO_CASO={ACESSOS.ASSISTENCIA.ID_MODULO}
                />
            </span>
        </li>
    );
}
